import React from "react";
import "./SavedUPSAccount.css";

const SavedUPSAccount = ({ addressList,rtvAddress, step, merchandiseType }) => {
  return (
    <>
      {addressList && step === "17" && (
        <div className="savedUPSAccount-container">
          <div className="savedUPSAccount-title">
            Saved UPS Account #'s and Addresses
          </div>

          <ul className="savedUPSAccount-list-container">
            {addressList.map((address, index) => (
              <li
                data-testid="savedUPSAccount-list-item"
                className="savedUPSAccount-list-item-container"
                key={index}
              >
                <div className="savedUPSAccount-list-item">
                  <b>{`Account # ${address.upsAccountNumber}`}</b>
                  <br />
                  {address.streetAddress}
                  <br />
                  {address.suiteUnitFloor && (
                    <>
                      {address.suiteUnitFloor}
                      <br />
                    </>
                  )}
                  {`${address.city}, ${address.state}, ${address.zipCode}, ${address.country}`}{" "}
                  <br />
                  {merchandiseType === "MP" &&
                    address?.preferredShippingName !== null && (
                      <>
                        <b>Preferred Shipping Name: </b>
                        {address?.preferredShippingName}
                      </>
                    )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
      {
        rtvAddress && step === "17" && (
          <div className="fedex-container">
            <div className="fedex-title">
              Saved Fedex Account # and Address
            </div>
            <div className="fedex-account-list-items">
              <p className="zero-margin"><label className="fedex-bold-title">Account # &nbsp; {rtvAddress.fedexAccountNumber}</label></p>
              <p className="zero-margin"><label className="fedex-bold-title">Address:</label>&nbsp;{rtvAddress.streetAddress}, {rtvAddress.city}, {rtvAddress.state}, {rtvAddress.zipCode}, {rtvAddress.country}</p>
              <p className="zero-margin"><label className="fedex-bold-title">Preferred Shipping Name:</label>&nbsp;{rtvAddress.preferredShippingName}</p>
            </div>
          </div>
        )
      }
    </>
  );
};

export default SavedUPSAccount;
